<template>
    <div class="error-alert-area">
        <b-alert 
            v-for="error in errorObjList"
            :key="error.id"
            variant="danger"
            show
            dismissible
            style="white-space: pre-wrap;"
        >{{ error.msg }}</b-alert>
    </div>
</template>

<script>
// USE THIS TO SHOW NON-TOAST ERRORS IN ALL COMPONENTS
import { nanoid } from 'nanoid';

export default {
    name: 'CoreErrorAlerts',
    components: {},
    mixins: [],
    props: {
        errors: {  // should be an array of error message strings -- each will get shown in its own alert
            type: Array,
            required: false,
        },
    },
    data: function() {
        return {}
    },
    computed: {
        errorObjList: function() {
            // take array of strings, turn into array of objects with unique ID for each one, just to make v-for happy
            return this.errors.map(errMsg => {
                return {
                    id: nanoid(),
                    msg: errMsg,
                }
            });
        },
    },
}
</script>

<style>

</style>